import React, { useState } from "react";

const github = "https://github.com/ykv749";
const linkedin = "https://www.linkedin.com/in/ykv749/";
const leetcode = "https://leetcode.com/ykv749/";
const resume =
  "https://drive.google.com/file/d/1uLrCKcVXgMBAYjxDsh4_y2m0tds0Zf2F/view?usp=drive_link";

const Icon = ({ name, size = 18 }) => {
  const paths = {
    arrow: (
      <>
        <path d="M5 12h14" />
        <path d="m13 6 6 6-6 6" />
      </>
    ),
    github: (
      <path
        d="M12 2.7a9.3 9.3 0 0 0-2.94 18.12c.47.09.64-.2.64-.45v-1.63c-2.62.57-3.17-1.12-3.17-1.12-.43-1.08-1.04-1.37-1.04-1.37-.85-.58.06-.57.06-.57.94.07 1.44.97 1.44.97.84 1.43 2.2 1.02 2.73.78.08-.6.33-1.02.6-1.25-2.1-.24-4.31-1.05-4.31-4.68 0-1.03.37-1.88.98-2.54-.1-.24-.42-1.2.09-2.51 0 0 .8-.26 2.56.97A8.9 8.9 0 0 1 12 7.43c.79 0 1.58.11 2.32.31 1.77-1.23 2.56-.97 2.56-.97.51 1.31.19 2.27.1 2.51.61.66.98 1.5.98 2.54 0 3.64-2.22 4.43-4.33 4.67.34.29.64.84.64 1.69v2.5c0 .25.17.55.65.45A9.3 9.3 0 0 0 12 2.7Z"
        fill="currentColor"
        stroke="none"
      />
    ),
    linkedin: (
      <>
        <path d="M6.2 9.2V18" />
        <path d="M6.2 5.8v.01" />
        <path d="M10.5 18v-5c0-2 1.25-3.8 3.5-3.8 2.25 0 3.2 1.6 3.2 3.8v5" />
        <path d="M10.5 12.7V9.2" />
      </>
    ),
    menu: (
      <>
        <path d="M4 7h16M4 12h16M4 17h16" />
      </>
    ),
    close: (
      <>
        <path d="m6 6 12 12M18 6 6 18" />
      </>
    ),
    download: (
      <>
        <path d="M12 3v12" />
        <path d="m7 10 5 5 5-5" />
        <path d="M5 21h14" />
      </>
    ),
    external: (
      <>
        <path d="M14 4h6v6" />
        <path d="M20 4 10 14" />
        <path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" />
      </>
    ),
    code: (
      <>
        <path d="m8 9-3 3 3 3M16 9l3 3-3 3M14 5l-4 14" />
      </>
    ),
    layers: (
      <>
        <path d="m12 3 8 4.5-8 4.5-8-4.5L12 3Z" />
        <path d="m4 12 8 4.5 8-4.5" />
        <path d="m4 16.5 8 4.5 8-4.5" />
      </>
    ),
    pin: (
      <>
        <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
        <circle cx="12" cy="10" r="2.4" />
      </>
    ),
  };
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name]}
    </svg>
  );
};
const LinkIcon = ({ href, label, icon }) => (
  <a
    className="icon-link"
    href={href}
    target="_blank"
    rel="noreferrer"
    aria-label={label}
  >
    <Icon name={icon} />
  </a>
);
const skills = [
  ["Languages", ["Golang", "Python", "JavaScript", "Java"]],
  [
    "Backend & architecture",
    [
      "Gin",
      "Spring Boot",
      "REST APIs",
      "FastAPI",
      "gRPC",
      "Microservices",
      "Distributed Systems",
      "Event-Driven Architecture",
      "System Design",
      "API Design",
      "Scalability",
      "High Availability",
    ],
  ],
  ["Data & messaging", ["PostgreSQL", "Redis", "Redis Delayed Queue"]],
  ["DevOps & observability", ["Docker", "Kubernetes", "Datadog", "Zenduty"]],
  ["Core CS", ["Data Structures & Algorithms", "DBMS", "OOP"]],
];
const work = [
  {
    company: "Poptech Growth Pvt Ltd",
    role: "SDE1 (Backend)",
    dates: "Jan 2024 — Sep 2026",
    location: "Bengaluru, Karnataka, India",
    current: false,
    points: [
      <>
        Designed and developed a <strong>Golang-based Card Orchestration
        Layer</strong> integrating with <strong>5 banks</strong>, handling
        <strong> ~50K requests/day</strong> and supporting <strong>1.5L+ users</strong>
        with <strong>p95 latency ≤500 ms</strong>.
      </>,
      <>
        Designed a configurable <strong>Business Rules Engine</strong> for
        <strong> 10 rules</strong> across <strong>~10K customers/day</strong>,
        improving card approval rates from <strong>50% to 70%</strong> while
        maintaining <strong>~500 ms evaluation latency</strong>.
      </>,
      <>
        Designed a centralized <strong>observability framework</strong> across
        5 card services using Datadog, monitoring p95 latency, error rates, and
        business metrics while reducing production incident detection time to
        <strong> ~5 minutes</strong>.
      </>,
      <>
        Engineered the <strong>Card Hybrid Journey</strong>, enabling a
        transition from web onboarding to app-based verification and driving
        an <strong>80% increase in app installs</strong> from the card
        acquisition funnel.
      </>,
      <>
        Built a <strong>Card Rewards System</strong> supporting
        <strong> ~8K reward transactions/day</strong> across
        <strong> 1.5L+ users</strong> with <strong>99.99% availability</strong>
        and <strong>&lt;1% failure/retry rate</strong>.
      </>,
    ],
  },
  {
    company: "Marmeto",
    role: "Frontend Developer",
    dates: "Jan 2023 — Dec 2023",
    location: "Bengaluru, Karnataka, India",
    current: false,
    points: [
      <>
        Developed and optimized e-commerce platforms for{" "}
        <strong>Orient Electric, USPA, and CycleAgarbatti</strong>, improving
        user experience and sales.
      </>,
      <>
        Implemented cart upsell and cross-sell features to{" "}
        <strong>boost average order value</strong>.
      </>,
    ],
  },
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  return (
    <div className="site-shell">
      <header className="nav-wrap">
        <nav className="nav" aria-label="Main navigation">
          <a className="brand" href="#top" onClick={closeMenu}>
            <span className="brand-dot" />
            Yash Kumar Verma
          </a>
          <button
            className="menu-button"
            type="button"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <Icon name={menuOpen ? "close" : "menu"} />
          </button>
          <div className={`nav-links ${menuOpen ? "open" : ""}`}>
            {["About", "Experience", "Projects", "Skills", "Contact"].map(
              (item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  onClick={closeMenu}
                >
                  {item}
                </a>
              ),
            )}
            <span className="nav-divider" />
            <LinkIcon
              href={github}
              label="Yash Kumar Verma on GitHub"
              icon="github"
            />
            <LinkIcon
              href={linkedin}
              label="Yash Kumar Verma on LinkedIn"
              icon="linkedin"
            />
            <LinkIcon
              href={leetcode}
              label="Yash Kumar Verma on LeetCode"
              icon="code"
            />
            <a
              className="resume-link"
              href={resume}
              target="_blank"
              rel="noreferrer"
            >
              Resume <Icon name="download" size={15} />
            </a>
          </div>
        </nav>
      </header>
      <main id="top">
        <section className="hero section-wrap">
          <div className="hero-copy reveal">
            <p className="eyebrow">
              <span className="pulse" />
              Available for meaningful engineering work
            </p>
            <h1>
              Backend systems,
              <br />
              <em>built to hold up.</em>
            </h1>
            <p className="hero-lede">
              I am Yash Kumar Verma, a Backend Engineer building
              distributed systems for high-volume card journeys—designed for
              fast decisions, clear observability, and dependable recovery.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#projects">
                Explore selected work <Icon name="arrow" />
              </a>
              <a
                className="button secondary"
                href={resume}
                target="_blank"
                rel="noreferrer"
              >
                View résumé <Icon name="download" />
              </a>
            </div>
            <div className="hero-social">
              <span>Find me on</span>
              <LinkIcon href={github} label="GitHub" icon="github" />
              <LinkIcon href={linkedin} label="LinkedIn" icon="linkedin" />
              <LinkIcon href={leetcode} label="LeetCode" icon="code" />
            </div>
          </div>
          <div
            className="terminal-wrap reveal delay-1"
            aria-label="Illustration of a successful backend service request"
          >
            <div className="terminal">
              <div className="terminal-bar">
                <span />
                <span />
                <span />
                <p>card-orchestration.service</p>
                <i>live</i>
              </div>
              <div className="terminal-body">
                <p>
                  <b>$</b> curl /v1/cards/eligibility
                </p>
                <p className="dim">→ routing request through rules engine</p>
                <div className="code-line">
                  <span className="key">status</span>
                  <span>:</span>
                  <span className="string"> 200</span>
                </div>
                <div className="code-line">
                  <span className="key">decision</span>
                  <span>:</span>
                  <span className="string"> "eligible"</span>
                </div>
                <div className="code-line">
                  <span className="key">trace</span>
                  <span>:</span>
                  <span className="string"> "captured"</span>
                </div>
                <p className="success">
                  <span>✓</span> response delivered · observable · resilient
                </p>
              </div>
            </div>
            <div className="floating-card metric">
              <span>approval rate</span>
              <strong>50 → 70%</strong>
              <small>Business Rules Engine</small>
            </div>
            <div className="floating-card incident">
              <span className="status-dot" />
              incident diagnosis <strong>~5 min</strong>
            </div>
          </div>
          <a className="scroll-cue" href="#about">
            <span>SCROLL TO EXPLORE</span>
            <i />
          </a>
        </section>
        <section className="section-wrap about-section" id="about">
          <div className="section-label">
            <span>01</span>
            <p>About</p>
          </div>
          <div className="about-grid">
            <h2>
              Engineering the paths <em>people depend on.</em>
            </h2>
            <div className="about-detail">
              <p>
                My work centers on backend systems that turn complex product
                rules into reliable customer journeys. At Poptech Growth Pvt Ltd, I
                build backend services across credit-card workflows—from multi-bank
                orchestration and rule evaluation to observability, rewards,
                and recovery.
              </p>
              <p>
                That means caring about both the interface and what happens
                after the request: system visibility, recovery paths, and
                thoughtful delivery under real constraints.
              </p>
              <div className="facts">
                <div>
                  <span>Current focus</span>
                  <strong>Backend Engineering</strong>
                </div>
                <div>
                  <span>Based in</span>
                  <strong>
                    <Icon name="pin" size={15} /> Bengaluru, India
                  </strong>
                </div>
                <div>
                  <span>Core stack</span>
                  <strong>Go · Gin · Java · SpringBoot · gRPC · PostgreSQL</strong>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-wrap experience-section" id="experience">
          <div className="section-label">
            <span>02</span>
            <p>Experience</p>
          </div>
          <div className="section-heading">
            <h2>
              Experience where <em>outcomes matter.</em>
            </h2>
            <p>Building systems and interfaces across fintech and commerce.</p>
          </div>
          <div className="timeline">
            {work.map((job) => (
              <article className="job" key={job.company}>
                <div className="job-meta">
                  <span
                    className={job.current ? "role-state live" : "role-state"}
                  >
                    {job.current ? "Current" : "Past role"}
                  </span>
                  <p>{job.dates}</p>
                  <p>{job.location}</p>
                </div>
                <div className="timeline-rail">
                  <i />
                </div>
                <div className="job-content">
                  <p className="company">{job.company}</p>
                  <h3>{job.role}</h3>
                  <ul>
                    {job.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </section>
        <section className="section-wrap work-section" id="projects">
          <div className="section-label">
            <span>03</span>
            <p>Selected work</p>
          </div>
          <div className="section-heading">
            <h2>
              Systems behind the <em>customer journey.</em>
            </h2>
            <p>Selected product systems from backend engineering work.</p>
          </div>
          <div className="work-grid">
            <article className="work-card">
              <div className="card-top">
                <span className="work-index">01 / CREDIT CARDS</span>
                <Icon name="code" />
              </div>
              <h3>Card Orchestration Layer</h3>
              <p>
                Developed a Golang-based layer that integrates five banking
                partners and supports card decisions at high daily volume.
              </p>
              <div className="tags">
                <span>Golang</span>
                <span>Gin</span>
                <span>gRPC</span>
                <span>REST APIs</span>
              </div>
              <div className="card-stat">
                <b>50K</b>
                <span>
                  requests/day across
                  <br />
                  2 banking partners
                </span>
              </div>
            </article>
            <article className="work-card">
              <div className="card-top">
                <span className="work-index">02 / OBSERVABILITY</span>
                <Icon name="layers" />
              </div>
              <h3>Card Ecosystem Visibility</h3>
              <p>
                Built centralized observability across five card services,
                tracking p95 latency, errors, and business metrics.
              </p>
              <div className="tags">
                <span>Datadog</span>
                <span>Zenduty</span>
                <span>Docker</span>
              </div>
              <div className="card-stat">
                <b>~5 min</b>
                <span>
                  early detection and
                  <br />
                  diagnosis time
                </span>
              </div>
            </article>
            <article className="work-card">
              <div className="card-top">
                <span className="work-index">03 / JOURNEYS</span>
                <Icon name="arrow" />
              </div>
              <h3>Card Hybrid Journey</h3>
              <p>
                Enabled the shift from web onboarding to app-based verification
                within the card acquisition funnel.
              </p>
              <div className="tags">
                <span>Golang</span>
                <span>System Design</span>
                <span>REST APIs</span>
              </div>
              <div className="card-stat">
                <b>+80%</b>
                <span>
                  app installs from the
                  <br />
                  acquisition funnel
                </span>
              </div>
            </article>
            <article className="work-card">
              <div className="card-top">
                <span className="work-index">04 / CARDHUB</span>
                <Icon name="code" />
              </div>
              <h3>Cardhub Service</h3>
              <p>
                Built a YesBank downstream service to handle BE requests in Java Spring Boot service to handle high-volume Cardhub
                requests reliably at scale.
              </p>
              <div className="tags">
                <span>Java</span>
                <span>Spring Boot</span>
                <span>REST APIs</span>
              </div>
              <div className="card-stat">
                <b>50K</b>
                <span>
                  requests handled
                  <br />
                  per day
                </span>
              </div>
            </article>
          </div>
        </section>
        <section
          className="section-wrap architecture-section"
          aria-labelledby="architecture-title"
        >
          <div className="section-label">
            <span>04</span>
            <p>Engineering approach</p>
          </div>
          <div className="architecture-grid">
            <div>
              <h2 id="architecture-title">
                Design for the request <em>and the recovery.</em>
              </h2>
              <p>
                From rule-driven card decisions to delayed recovery journeys,
                the work is about fast paths, visible systems, and operations
                that hold steady under load.
              </p>
            </div>
            <div
              className="architecture-diagram"
              aria-label="Customer request flows through rules, partner and card systems, with observability across the journey"
            >
              <div className="flow-node">
                <span>01</span>
                <strong>
                  Customer
                  <br />
                  request
                </strong>
              </div>
              <i />
              <div className="flow-node">
                <span>02</span>
                <strong>
                  Card
                  <br />
                  orchestration
                </strong>
              </div>
              <i />
              <div className="flow-node">
                <span>03</span>
                <strong>
                  Rules &amp;
                  <br />
                  journeys
                </strong>
              </div>
              <i />
              <div className="flow-node">
                <span>04</span>
                <strong>
                  Partner &amp;
                  <br />
                  card systems
                </strong>
              </div>
              <div className="observe">
                <span className="status-dot" /> Observability across the journey
              </div>
            </div>
          </div>
        </section>
        <section className="section-wrap skills-section" id="skills">
          <div className="section-label">
            <span>05</span>
            <p>Technical toolkit</p>
          </div>
          <div className="section-heading">
            <h2>
              Tools in service <em>of good systems.</em>
            </h2>
            <p>A focused toolkit drawn directly from my work.</p>
          </div>
          <div className="skills-grid">
            {skills.map(([title, items], index) => (
              <article className="skill-group" key={title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{title}</h3>
                <div>
                  {items.map((item) => (
                    <b key={item}>{item}</b>
                  ))}
                </div>
              </article>
            ))}
          </div>
          <div className="recognition">
            <div>
              <p className="eyebrow">Recognition</p>
              <h3>Got Popstar Employee Reward 2025</h3>
              <p>Poptech Growth Pvt Ltd</p>
            </div>
            <div>
              <p className="eyebrow">Problem solving</p>
              <h3>LeetCode Knight · 2064 rating</h3>
              <p>
                1100+ problems solved · 1930 rank out of 16.9k in Biweekly
                Contest 94 · 1650 rank out of 18.3k in Weekly Contest 324
              </p>
            </div>
          </div>
          <aside className="activity-callout" aria-labelledby="activity-title">
            <div className="activity-intro">
              <p className="eyebrow">Co-curricular activity</p>
              <h3 id="activity-title">Fitness</h3>
              <p>
                Sharing fitness activity outside of engineering through
                <strong> @fit.with.ykv749</strong>.
              </p>
            </div>
            <div className="activity-embeds">
              <iframe
                className="instagram-embed"
                src="https://www.instagram.com/p/Dd6sb-TEwd0/embed/captioned/"
                title="Fitness activity on Instagram — post 1"
                loading="lazy"
                scrolling="no"
              />
              <iframe
                className="instagram-embed"
                src="https://www.instagram.com/p/Dd2AgSSEwCC/embed/captioned/"
                title="Fitness activity on Instagram — post 2"
                loading="lazy"
                scrolling="no"
              />
            </div>
            <div className="activity-links">
              <a href="https://www.instagram.com/fit.with.ykv749/" target="_blank" rel="noreferrer">
                View on Instagram <Icon name="external" size={14} />
              </a>
            </div>
          </aside>
        </section>
        <section className="section-wrap education-section">
          <div className="section-label">
            <span>06</span>
            <p>Education</p>
          </div>
          <div className="education-card">
            <p className="school">PSIT College of Engineering, Kanpur</p>
            <h2>
              B.Tech <span>(CSE)</span>
            </h2>
            <p>2018 — 2022</p>
          </div>
        </section>
        <section className="contact" id="contact">
          <div className="contact-inner">
            <p className="eyebrow">
              <span className="pulse" />
              Open to conversations
            </p>
            <h2>
              Let’s build something <em>great.</em>
            </h2>
            <p>
              Whether you’re hiring or thinking through a hard engineering
              problem, I’d be glad to connect.
            </p>
            <a className="contact-email" href="mailto:ykv749@gmail.com">
              ykv749@gmail.com <Icon name="arrow" />
            </a>
            <div className="contact-links">
              <a href={github} target="_blank" rel="noreferrer">
                <Icon name="github" /> GitHub <Icon name="external" size={14} />
              </a>
              <a href={linkedin} target="_blank" rel="noreferrer">
                <Icon name="linkedin" /> LinkedIn{" "}
                <Icon name="external" size={14} />
              </a>
              <a href={leetcode} target="_blank" rel="noreferrer">
                <Icon name="code" /> LeetCode <Icon name="external" size={14} />
              </a>
              <a href={resume} target="_blank" rel="noreferrer">
                <Icon name="download" /> Résumé
              </a>
            </div>
          </div>
        </section>
      </main>
      <footer>
        <a className="brand" href="#top">
          <span className="brand-dot" />
          Yash Kumar Verma
        </a>
        <p>Backend Engineer · Distributed Systems</p>
        <span>© {new Date().getFullYear()}</span>
      </footer>
    </div>
  );
}
export default App;
